export const tarea = [
  {
    label: "Id",
    name: "idtarea",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Nombre",
    name: "nombre",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
];
